import { render, staticRenderFns } from "./ThirdPage.vue?vue&type=template&id=9ad7dfe8&scoped=true"
import script from "./ThirdPage.vue?vue&type=script&lang=js"
export * from "./ThirdPage.vue?vue&type=script&lang=js"
import style0 from "./ThirdPage.vue?vue&type=style&index=0&id=9ad7dfe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad7dfe8",
  null
  
)

export default component.exports